module.exports = __webpack_public_path__ + "img/pause.3d74bb7b.svg";